export class ChangeEmailCredentials {
    public password: string;
    public newEmail: string;
    public newEmailRepeat: string;

    constructor() {
        this.password = '';
        this.newEmail = '';
        this.newEmailRepeat = '';
    }
}
